import React, { Component } from 'react';
import './Project.css';
import { Redux, ReactLogo, Firebase, Scss, Postgres, Aws } from '../Logos/Logos'


class Project extends Component {
  constructor(props) {
    super(props)

    this.state = {
      active: ''
    }
  }

  renderEvo = () => {
    return (
      <div className='big-project'>
        <div className='project-section'>
        <div className='p-picture-evo'></div>
        <div className='p-description'>
        <i class="material-icons right" onClick={this.props.displayProject}>close</i>
          <h1>Project</h1>
            <p>Web development and all online marketing for Evo-Lite</p>
          <h1>Process</h1>
            <p>When approached by Evo-Lite originally, they had a very simple, static website with very little content. As a growing company they required a site that could expand to meet their needs as they matured. We designed a website that could be updated easily and included the many features they required, including: photo gallery, web chat, landing pages for newsletter leads, product documentation hub, multiple contact forms, and dynamic product pages. </p>
          <h1>Tech Stack</h1>
            <div className='t-logos'>
              <Redux/>
              <ReactLogo />
              <Postgres />
            </div>
        </div>
        </div>
      </div>
    )
  }

  renderMain = () => {
    return (
      <div className='big-project'>
        <div className='project-section'>
        <div className='p-picture-main'></div>
        <div className='p-description'>
        <i class="material-icons right" onClick={this.props.displayProject}>close</i>
          <h1>Project</h1>
            <p>Responsive Web Application</p>
          <h1>Process</h1>
            <p>This day / night planning app was created to help people organize there day by providing three plans to choose from which include something to do before an event, the event, and what to do after based on selected filters.

Ticketmaster's API was used to display upcoming events in the selected city or the event chosen by the user. Google was used to display a map with walking directions to the event and to provide autoselect options for the location. Finally, Yelp provided the restaurants and bars that the user can sort by type of restaurant and price range. The highest rated restaurants & bars within walking distance are ultimately displayed in each plan. </p>
          <h1>Tech Stack</h1>
            <div className='t-logos'>
              <Redux/>
              <ReactLogo />
              <Firebase />
              <Postgres />
            </div>
        </div>
        </div>
      </div>
    )
  }

  renderViridis = () => {
    return (
      <div className='big-project'>
        <div className='project-section'>
        <div className='p-picture-viridis'></div>
        <div className='p-description'>
        <i class="material-icons right" onClick={this.props.displayProject}>close</i>
          <h1>Project</h1>
            <p>WEBSITE DESIGN + DEVELOPMENT</p>
          <h1>Process</h1>
            <p>The client for this project was an interior designer who’s current website was loading extremely slowly due to the hundreds of large photos on the site in combination with the way it was set up. The top priority was to develop a site that allowed for easy photo uploading as well as minimizing page load times.

To meet the clients expectations we decided to move the website from a static site to a lightweight and clean WordPress template. In doing this we were able to make the addition of project photos something the client could do herself, greatly improved site speed, and made it mobile friendly.</p>
          <h1>Tech Stack</h1>
            <div className='t-logos'>
              <Redux/>
              <ReactLogo />
              <Firebase />
              <Postgres />
            </div>
        </div>
        </div>
      </div>
    )
  }

  renderAWC = () => {
    return (
      <div className='big-project'>
        <div className='project-section'>
        <div className='p-picture-awc'></div>
        <div className='p-description'>
        <i class="material-icons right" onClick={this.props.displayProject}>close</i>
          <h1>Project</h1>
            <p>Web and Mobile application</p>
          <h1>Process</h1>
            <p>AWC is social media app for dancers. The task was to create a unique, totally new vision of the service for the client. The website had to stand out from the similar ones, be noticeable and remarkable for a user. Inspired with the task, based on user research and market exploration, the designer decided to solve this task using color and shapes, searching for the perfect combination of this methods. </p>
          <h1>Tech Stack</h1>
            <div className='t-logos'>
              <Redux/>
              <ReactLogo />
              <Scss />
              <Postgres />
              <Aws />
            </div>
        </div>
        </div>
      </div>
    )
  }

  render() {
    console.log(this.props.activeProject)
    switch (this.props.activeProject) {
      case 'main':
        this.state.active = this.renderMain()
        break;
      case 'evo':
        this.state.active = this.renderEvo()
        break;
      case 'viridis':
        this.state.active = this.renderViridis()
        break;
      case 'awc':
        this.state.active = this.renderAWC()
        break;
    }
    
    return (
      <div className='big-project'>
        {this.state.active};
      </div>
    );
  }
}

export default Project;


// WEBPACK FOOTER //
// ./src/Project/Project.js